import React from 'react';
import Icon from '@ant-design/icons';
import  {GetProps } from 'antd';

type CustomIconComponentProps = GetProps<typeof Icon>;

const SlideSvg = () => (
<svg  viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="14" height="14"><path d="M554.666667 896v85.333333h-85.333334v-85.333333H128a42.666667 42.666667 0 0 1-42.666667-42.666667V256h853.333334v597.333333a42.666667 42.666667 0 0 1-42.666667 42.666667h-341.333333z m-384-85.333333h682.666666V341.333333H170.666667v469.333334z m384-384h213.333333v85.333333h-213.333333v-85.333333z m0 170.666666h213.333333v85.333334h-213.333333v-85.333334z m-170.666667-170.666666v128h128a128 128 0 1 1-128-128zM85.333333 128h853.333334v85.333333H85.333333V128z"  ></path></svg>
  );

export const SlideIcon = (props: Partial<CustomIconComponentProps>) => (
<Icon component={SlideSvg} {...props} />
);

export  default  SlideIcon